import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {FileService} from '../../../../services/file.service';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {MessageService} from '../../../../services/message.service';
import {ParentInfoDialogComponent} from '../../../settings/parents-list/parent-info-dialog/parent-info-dialog.component';
import {MyMessagesDialogComponent} from '../../../shared/my-messages-dialog/my-messages-dialog.component';

@Component({
    selector: 'app-left-side',
    templateUrl: './left-side.component.html',
    styleUrls: ['./left-side.component.scss']
})
export class LeftSideComponent implements OnInit {
    @Input() user;
    @Input() notifications;
    @Output() selectedMode: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectHistory: EventEmitter<any> = new EventEmitter<any>();
    imageSource: any;
    appVersion: string;
    messageTotal: number;

    constructor(private localStorageService: LocalStorageService,
                public fileService: FileService,
                private messageService: MessageService,
                public dialog: MatDialog,
                public router: Router) {
        this.appVersion = environment.version;
    }

    async ngOnInit() {
        await this.getLogo();
        await this.getUnreadMessagesNumber();
    }

    async getUnreadMessagesNumber() {
        try {
            this.messageTotal = await this.messageService.getUserUnreadMessagesTotal();
        } catch (e) {
            console.log(e.message);
        }
    }

    async logout() {
        this.localStorageService.clear('user');
        this.localStorageService.clear('token');
        await this.router.navigate(['login']);
    }

    navigateToHistory() {
        this.selectHistory.emit(true);
    }

    async getLogo() {
        try {
            const res = await this.fileService.downloadFile(`college/logo`);
            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
                this.imageSource = reader.result;
            };
        } catch (e) {
            this.imageSource = '';
        }
    }

    showMyMessages() {
        this.dialog.open(MyMessagesDialogComponent, {
            width: '60%',
            height: '550px'
        });
    }

    showParentSettings() {
        this.user.userId = this.user.id;
        this.dialog.open(ParentInfoDialogComponent, {
            data: {
                parent: this.user
            }
        });
    }

    switchToChildConsents() {
        this.selectedMode.emit('consents');
    }

    switchToHistoryConsents() {
        this.selectedMode.emit('history');
    }

    switchToMessages() {
        this.selectedMode.emit('messages');
    }
}
